import BoxSizes from "../enums/BoxSizes";

export default function getBoxSize(width, length, height) {
  const mass = width * height * length;

  for (const box in BoxSizes) {
    const volume =
      BoxSizes[box].width * BoxSizes[box].length * BoxSizes[box].height;

    if (mass <= volume) {
      return box;
    }
  }

  return "سایر";
}
